var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenMatter1234(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 560,
    viewBox: "0 0 560 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.619 284.144C386.372 280.28 377.16 273.498 371.14 269.068C370.02 268.24 368.53 268.122 367.292 268.749C366.049 269.371 365.271 270.648 365.271 272.031V272.91H273.806V165.149C273.806 157.32 267.461 150.981 259.638 150.981C259.632 150.981 259.632 150.981 259.632 150.981C253.971 150.981 249.104 154.308 246.831 159.107C238.184 153.742 227.998 150.64 217.084 150.64C185.858 150.64 160.507 175.991 160.507 207.216C160.507 238.442 185.858 263.793 217.084 263.793C227.427 263.793 237.115 260.999 245.464 256.144V272.91H220.175C219.15 272.854 218.12 272.82 217.089 272.82C185.864 272.82 160.512 298.172 160.512 329.397C160.512 360.617 185.864 385.968 217.089 385.968C248.309 385.968 273.666 360.617 273.666 329.397C273.666 327.885 273.588 326.396 273.47 324.923H273.806V301.252H365.271V302.187C365.271 303.576 366.055 304.847 367.292 305.474C368.536 306.101 370.02 305.978 371.14 305.155C377.16 300.72 386.372 293.938 391.619 290.08C392.56 289.38 393.12 288.282 393.12 287.112C393.125 285.941 392.565 284.838 391.619 284.144ZM217.084 235.502C201.471 235.502 188.798 222.829 188.798 207.216C188.798 191.604 201.471 178.931 217.084 178.931C232.696 178.931 245.369 191.604 245.369 207.216C245.375 222.829 232.696 235.502 217.084 235.502ZM245.492 326.933C245.481 327.768 245.459 328.58 245.375 329.38V329.392C245.375 344.999 232.702 357.677 217.089 357.677C201.476 357.677 188.804 344.999 188.804 329.392C188.804 314.339 200.58 302.024 215.409 301.156V301.246H245.47C245.47 315.576 245.47 324.917 245.47 324.917H245.509C245.38 325.567 245.504 326.295 245.492 326.933Z",
    fill: "url(#paint0_linear_1686_3088)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M305.648 190.915L286.826 220.321L296.861 220.371C301.185 239.669 318.405 254.178 339.007 254.285C345.201 254.318 351.103 253.041 356.451 250.717L339.393 249.67L346.696 236.409C344.282 237.115 341.734 237.49 339.097 237.479C327.852 237.423 318.248 230.361 314.412 220.455L324.178 220.505L305.648 190.915Z",
    fill: "url(#paint1_linear_1686_3088)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M373.027 189.264L357.19 191.274C362.533 196.174 365.87 203.214 365.831 211.014C365.803 216.95 363.815 222.433 360.494 226.846L356.233 219.095L339.388 249.677L374.237 251.81L369.051 242.391C377.361 234.523 382.575 223.418 382.637 211.098C382.709 196.348 375.385 183.261 364.145 175.354L373.027 189.264Z",
    fill: "url(#paint2_linear_1686_3088)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M350.023 168.835C346.64 167.967 343.095 167.491 339.444 167.474C317.145 167.362 298.637 184.167 296.111 205.823L305.648 190.927L313.617 203.661C316.787 192.439 327.147 184.218 339.36 184.279C340.486 184.285 341.595 184.363 342.687 184.503L338.397 193.659L373.033 189.269L354.239 159.847L350.023 168.835Z",
    fill: "url(#paint3_linear_1686_3088)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M289.497 218.938L298.104 218.983L298.345 220.069C302.584 238.986 319.737 252.79 339.13 252.891H339.348C342.759 252.891 346.113 252.487 349.372 251.681L337.22 250.936L344.08 238.482C342.523 238.751 340.939 238.885 339.348 238.885H339.203C333.474 238.857 327.969 237.104 323.282 233.811C318.707 230.597 315.229 226.156 313.219 220.971L312.479 219.055L321.759 219.1L305.759 193.536L289.497 218.938Z",
    fill: "url(#paint4_linear_1686_3088)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M368.211 241.377C376.627 233.403 381.298 222.651 381.359 211.093C381.41 200.777 377.647 190.91 370.988 183.277L375.524 190.378L360.292 192.31C364.845 197.445 367.393 204.126 367.354 211.025C367.326 217.085 365.383 222.847 361.737 227.691L360.438 229.416L356.355 222.001L341.807 248.422L371.912 250.265L367.432 242.122L368.211 241.377Z",
    fill: "url(#paint5_linear_1686_3088)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M354.547 162.736L350.924 170.476L349.798 170.19C346.466 169.333 343.022 168.891 339.561 168.874H339.343C320.555 168.874 304.393 181.272 299.135 198.7L305.782 188.312L313.364 200.43C317.592 189.964 327.88 182.88 339.343 182.88H339.488C340.653 182.885 341.829 182.964 342.988 183.115L344.887 183.361L340.86 191.952L370.781 188.16L354.547 162.736Z",
    fill: "url(#paint6_linear_1686_3088)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1686_3088",
    x1: 160.509,
    y1: 268.302,
    x2: 393.124,
    y2: 268.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E5384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2002,
    stopColor: "#0E4D80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4706,
    stopColor: "#0F3C74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7798,
    stopColor: "#112060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12074F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1686_3088",
    x1: 339.184,
    y1: 257.819,
    x2: 298.338,
    y2: 204.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00692B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DB14B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1686_3088",
    x1: 360.899,
    y1: 251.744,
    x2: 361.288,
    y2: 175.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00692B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DB14B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1686_3088",
    x1: 297.689,
    y1: 198.743,
    x2: 358.225,
    y2: 176.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00692B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DB14B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1686_3088",
    x1: 294.134,
    y1: 196.913,
    x2: 335.719,
    y2: 255.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00692B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DB14B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1686_3088",
    x1: 380.081,
    y1: 182.668,
    x2: 355.093,
    y2: 251.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00692B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DB14B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1686_3088",
    x1: 334.572,
    y1: 158.884,
    x2: 334.851,
    y2: 183.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00692B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DB14B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenMatter1234);
export default __webpack_public_path__ + "static/media/GreenMatter1234.43eb01f47ac5a48bdc63633c86567611.svg";
export { ForwardRef as ReactComponent };